export const enum AppRoutes {
    LandingPage = '/login',
    SettingsPage = '/settings',
    HomePage = '/',
    NewAllocation = '/allocation/new',
    PreAllocation = '/allocation/pre',
    ReviewAllocation = '/allocation/review',
    AllocationHistory = '/allocation/history',
    AllocatingLoading = '/allocation/loading',
    AllocationDashboard = '/dashboard',
    LogoutPage = '/logout',
    CookiesPage = '/cookies',
    TandC = '/tandc',
    PrivacyPage = '/privacy',
    ContactPage = '/contact',
    AccessibilityStatement = '/accessibility',
    UserManagement = `/admin/userManagement`,
    Unauthorized = '/403',
    BusinessUnitManagement = '/admin/businessUnitManagement',
    BusinessRuleManagement = `/admin/businessRuleManagement`,
    BusinessMetrics = '/admin/businessMetrics',
}

export const LoginRedirectStorageKey = 'returnRoute';

export const enum SampleLinks {
    CostCentre = 'https://pwcgbr.sharepoint.com/:x:/t/GB-INT-IFS-LoS-Asset-Portfolio/EWVSGGo4DlpCluT7tk7iSYUB95-NaI3gZAkmx-R8asZhfg?e=d7XbaX',
    Capability = 'https://pwcgbr.sharepoint.com/:x:/t/GB-INT-IFS-LoS-Asset-Portfolio/EXnx8gq-TsZBtaY2IwV_n-wBgzLWDSKgKQHJYloRWg7P_g?e=hETLQM',
}
